import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';
import ExpenseTypeTable from './shared/ExpenseTypeTable';
import AddExpenseType from './shared/AddExpenseType';
import { useState } from 'react';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const ExpenseType = () => {
  const [apiCall, setApiCall] = useState(false);
  function handleApiCall() {
    setApiCall((prev) => !prev);
  }
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <AddExpenseType handleApiCall={handleApiCall} />
            <ExpenseTypeTable handleApiCall={handleApiCall} apiCall={apiCall} />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default ExpenseType;
